import { render, staticRenderFns } from "./ProductCardFitment.vue?vue&type=template&id=f5b59b36&scoped=true&"
import script from "./ProductCardFitment.vue?vue&type=script&lang=ts&"
export * from "./ProductCardFitment.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCardFitment.vue?vue&type=style&index=0&id=f5b59b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b59b36",
  null
  
)

export default component.exports